import { Suspense } from 'react';
import { ConstructorPageTemplateSelect } from './ConstructorPageTemplateSelect';
import { ConstructorPageTemplateSelectStub } from './ConstructorPageTemplateSelectStub';
import { type ConstructorPageTemplateSelectProps } from './types';

export const ConstructorPageTemplateSelectSuspense = (props: ConstructorPageTemplateSelectProps) => (
    <Suspense fallback={<ConstructorPageTemplateSelectStub {...props} />}>
        <ConstructorPageTemplateSelect {...props} />
    </Suspense>
);
